/* eslint-disable no-prototype-builtins */
export const isObject = (input: unknown) => {
  return (
    input !== null &&
    typeof input === 'object' &&
    Object.getPrototypeOf(input).isPrototypeOf(Object)
  )
}
